import PropTypes from 'prop-types';

const ContractorLineItemType = PropTypes.shape({
  description: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  item_number: PropTypes.string,
  line_item_id: PropTypes.number,
  price: PropTypes.number,
  quantity: PropTypes.number,
  labor_sheet_id: PropTypes.number,
  note: PropTypes.string,
});

export default ContractorLineItemType;



// WEBPACK FOOTER //
// ./client/app/shared/types/contractorLineItem.js